import { useEffect, useState } from "react";
import Checkbox from "../components/Checkbox";
import { store } from "../stores/Store";
import { Modal } from "../components/Modal";
import { observer } from "mobx-react-lite";
import { Button } from "../components/Button";
import './CartSummaryModal.scss';
import Input from "../components/Input";
import ErrorIcon from "../icons/ErrorIcon";
import { publicUrl } from "../utils/url";
import BedIcon from "../icons/BedIcon";
import GrayBox from "../components/GrayBox";
import { Tabs } from "../components/Tabs";
import ConfigurableCard, { ConfigurableOption } from "../components/ConfigurableCard";
import Select2 from "../components/Select2";
import { CounterInput } from "../components/CounterInput";
import { useWindowSize } from "../effects/useWindowSize";
import { BREAKPOINT_SM } from "../stores/constants";
import Collapse from "../components/Collapse";
import { SummaryRender } from "./SummaryModal";
import { formatCurrency } from "../utils/Currency";
import ProductModel from "../stores/ProductModel";
import { use } from "react";
import { _t } from '../utils/Lang';
import CartMattressBanner from '../components/CartMattressBanner';

const TabContent = observer(({ products = [], tabId, className = '' }) => {
    return <div className="bg-lightgray" style={{ padding: `var(--padding)` }}>

        <div className="d-flex g-2 pb-3" style={{ overflowX: 'scroll' }}>

            {products.map((item: ProductModel, index) => {

                const hasOptions = item.options_configuration?.length > 0;
                const canSelectQuantity = item.enable_quantity_selection;

                return <ConfigurableCard
                    product={item}
                    className={'no-pointer name-2-lines'}
                    horizontalBreakpoint={false}
                    badgeText={item.badgeText}
                    key={index}
                    style={{ width: 262, minWidth: 262, maxWidth: 350 }}
                    // onClick={() => {
                    //     store.selectMattress(item);
                    // }}
                    // onMoreClick={() => {
                    //     store.openMattressDetailsPopup();
                    //     // debugger;
                    // }}
                    onMoreLinkClick={() => {
                        window.open(item.url, '_blank');

                    }}
                    onAddToCartClick={async () => {
                        console.group('onAddToCartClick');
                        if (item.hasSizes) {

                            for await (const size of item.sizes) {
                                await store.cart.addProductToCart(size);
                                console.log({
                                    size,
                                    inCart: size.inCart
                                });
                            }
                            item.sizes.at(0).owner.inCart = true;


                        } else {
                            await store.cart.addProductToCart(item);
                        }
                        console.groupEnd();
                    }}
                    inCart={item.inCart}
                    bestseller={item.id === 1}
                    image={item.image}
                    name={item.name}
                    // description={item.description}
                    price={item.priceSum}
                    // checked={item.id === store.selectedMattressId}

                    attributes2Header=""
                    attributes2={item.attributes}

                >
                    {/* <div className="d-flex w-100 mt-3 mb-2">
                        <div className="mr-auto"><b>Twardość materaca</b></div>
                        <div>
                            <a href="#" onClick={e => {
                                e.preventDefault();
                                store.openHardnessPopup();
                            }}>Jak wybrać?</a>
                        </div>

                    </div> */}

                    {/* when have sizes */}
                    {item.sizes.map((item, sizeIndex) => {
                        return <div
                            key={sizeIndex}
                            className="w-100 d-flex f-col"
                            data-product-id={item.id}
                        >

                            {
                                item.options_configuration.map((o, index) => {
                                    return <ConfigurableOption
                                        inCart={item.inCart}
                                        key={index}
                                        index={index}
                                        option={o}
                                        item={item}
                                    />
                                })
                            }

                        </div>
                    })}
                    {/* when no sizes available but there are configuration options */}
                    {item.sizes.length === 0 ? (
                        <div

                            className="w-100 d-flex f-col"
                            data-product-id={item.id}
                        >

                            {
                                item.options_configuration.map((o, index) => {
                                    return <ConfigurableOption
                                        inCart={item.inCart}
                                        key={index}
                                        index={index}
                                        option={o}
                                        item={item}
                                    />
                                })
                            }

                        </div>
                    ) : null}
                    {(canSelectQuantity && item.sizes.length === 0) ? (
                        <div className="d-flex mb-1 mt-2">
                            <CounterInput value={item.quantity} onChange={value => { item.updateQuantity(value) }} />
                        </div>
                    ) : null}

                    {(item.canAddMoreSizes && canSelectQuantity && hasOptions && item.inCart === false) ? (
                        <a href="#" onClick={e => {
                            e.preventDefault();
                            item.addSize();
                        }}> {_t('add_dimension')}</a>
                    ) : null}
                </ConfigurableCard>
            })}
        </div>

    </div>
})

const CartSummaryModal = observer(({ defaultCategoryId }) => {

    const [tabId, setTabId] = useState(defaultCategoryId);
    const windowSize = useWindowSize();
    const compact = windowSize.width < BREAKPOINT_SM;

    // add effect when defaultCategoryId changes update stage
    useEffect(() => {
        if (defaultCategoryId !== tabId) {
            setTabId(defaultCategoryId);
        }
    }, [defaultCategoryId])



    const tabsContent = store.upsellCategories.map((category, index) => {
        return {
            id: category.id,
            title: category.name,
            content: <TabContent
                key={index}
                tabId={category.id}
                products={store.getUpsellProductsFromCategory(category.id)} />
        }
    })

    const configurationDetails = <SummaryRender className="GrayBox me-3" />
    // <GrayBox className="GrayBox--plain">
    //     <div className="GrayBox__row">
    //         <div className="GrayBox__label">
    //             Rozmiar powierzchni spania:
    //         </div>
    //         <div className="GrayBox__value">
    //             160 x 200cm
    //         </div>
    //     </div>
    //     <div className="GrayBox__row">
    //         <div className="GrayBox__label">
    //             Wysokość wezgłowia:
    //         </div>
    //         <div className="GrayBox__value">
    //             90cm
    //         </div>
    //     </div>
    //     <div className="GrayBox__row">
    //         <div className="GrayBox__label">
    //             Kolekcja tkanin:
    //         </div>
    //         <div className="GrayBox__value">
    //             Jasmine
    //         </div>
    //     </div>
    //     <div className="GrayBox__row">
    //         <div className="GrayBox__label">
    //             Kolor:
    //         </div>
    //         <div className="GrayBox__value">
    //             LEGEND 01 <div className="GrayBox__color" style={{ background: '#000' }}></div>
    //         </div>
    //     </div>
    //     <div className="GrayBox__row">
    //         <div className="GrayBox__label">
    //             Tył wezgłowia:
    //         </div>
    //         <div className="GrayBox__value">
    //             Tapicerowany
    //         </div>
    //     </div>
    //     <div className="GrayBox__row">
    //         <div className="GrayBox__label">
    //             Cena brutto:
    //         </div>
    //         <div className="GrayBox__value">
    //             3 340,00 zł
    //         </div>
    //     </div>
    // </GrayBox>

    // const saveProject = store.saveProject;
    return (
        <Modal
            className="no-padding modal-lg modal-sm-full"
            onClose={e => {
                store.closeCartSummaryPopup();
            }}
            isOpen={store.isCartSummaryPopupOpen}
            footerClassName="d-flex g-2 j-end p-2 p-md-3 bg-white"
            footer={<>
                <Button onClick={() => {
                    store.closeConfigurator();
                }} className="btn btn-md primary hollow mr-auto w-100 w-md-auto">{_t('continue_shopping')}</Button>
                <Button onClick={() => {
                    store.commitBasketReturnUrl();
                    window.location.assign('/basket');
                }} className="btn btn-md primary w-100 w-md-auto">{_t('go_to_cart')}</Button>
            </>}

        >
            <div className="CartSummaryModal d-flex f-col ">
                <div className="row g-0">
                    <div className="col-12 order-md-2">
                        <div className="modal-padding pb-0">
                            <div className='d-flex a-center mt-0 c-h3 pe-3'><BedIcon className="me-2" /> {_t('cart_added_title')}</div>
                            {compact ? (<>
                                <div className="row">
                                    <div className="col-12 pb-3">
                                        <div className="CartSummaryModal__photo px-5">
                                            <img src={store.renderPlainImageUrl} alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 pb-3">
                                        <div className="row">
                                            <div className="col-5">
                                                <p className="c-p-bigger ">{store.product?.name}</p>

                                            </div>
                                            <div className="col-7">
                                                <p><b>{_t('price_gross')}</b> {formatCurrency(store.cart.totalPrice)}</p>

                                            </div>
                                        </div>
                                        <Collapse
                                            title={() => {
                                                return <>

                                                    <span className="t-underline">{_t('expand_config')}</span> <svg className="Collapse__arrow" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M6.00056 6.99988L0.282227 1.28154L1.04473 0.519043L6.00056 5.47488L10.9564 0.519043L11.7189 1.28154L6.00056 6.99988Z" fill="#1F1F1F" />
                                                    </svg>
                                                </>

                                            }}
                                            open={true} className="">
                                            {configurationDetails}
                                        </Collapse>
                                    </div>
                                </div>
                            </>
                            ) : (

                                <div className="row">
                                    <div className="col-12 col-md-4">
                                        <div className="CartSummaryModal__photo">
                                            <img src={store.renderPlainImageUrl} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-8 pb-4">
                                        <p className="c-p-bigger mb-1">{store.product?.name}</p>
                                        <div style={{
                                            maxHeight: 180,
                                            overflow: 'auto'
                                        }}>
                                            {configurationDetails}
                                        </div>




                                    </div>
                                </div>
                            )}
                            <CartMattressBanner />

                            <p className="c-h3">
                                <b>{_t('comfort_title')} </b> {_t('comfort_desc')}
                            </p>

                            <Tabs
                                className={`Tabs--reverse modal-padding--reverse`}
                                selectedTab={tabId}
                                tabs={tabsContent}
                            />



                        </div>


                    </div>


                </div>



            </div>


        </Modal>
    )
});

export default CartSummaryModal